import(/* webpackMode: "eager" */ "/codebuild/output/src244309680/src/apps/junonkuji/src/app/error.tsx");
